import { CrmApiElement } from '@/models/base';

export interface ServiceProviderToken extends CrmApiElement {
    token: string;
}

export enum ServiceProvider {
    CHAMAILEON = '1'
}
